import { render, staticRenderFns } from "./UnacknowledgedHrDocumentsList.vue?vue&type=template&id=16fa1f14&scoped=true&"
import script from "./UnacknowledgedHrDocumentsList.vue?vue&type=script&lang=js&"
export * from "./UnacknowledgedHrDocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./UnacknowledgedHrDocumentsList.vue?vue&type=style&index=0&id=16fa1f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa1f14",
  null
  
)

export default component.exports